// @core/api/endpoints/form/get_form_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormTypeDefinitionResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form type
 * Returns a form type definition by ID or slug.
 */
export async function GetFormType(
  type_id: string,
  options?: RequestOptions
): Promise<FormTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.get<FormTypeDefinitionResponse>(requestPath, { ...requestOptions });
}
